<template>
  <div class="info">
    <div class="info__content">
      <h4 v-if="label" class="info__label">{{ label }}</h4>
      <h2>{{ message }}</h2>
      <p>{{ description }}</p>
      <a
        v-if="!disableAction"
        class="info__docs info__docs--desktop"
        href="https://docs.drct.aero/"
        @click="tryClick"
        >{{ $t('exploreDocs') }}</a
      >
    </div>
    <a
      v-if="!disableAction"
      class="info__docs info__try-mobile"
      href="https://docs.drct.aero/"
      @click="tryClick"
      >{{ $t('exploreDocs') }}</a
    >
  </div>
</template>

<script>
import { AmplitudeEvent } from 'components/shared/amplitude.js';
export default {
  props: {
    message: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    disableAction: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ""
    }
  },
  methods: {
    tryClick(){
    }
  }
}
</script>

<style lang="scss" scoped>
@use '../landing/demo-button' as *;

.info {
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 767px) {
    flex-direction: column;
    padding-top: 0;
  }
}

.info__docs {
  @include demo-button;
  color: white;
  opacity: 0.9;
  background-color: rgb(42, 138, 234);

  &:hover,
  &:active {
    background: #1a7dd4;
    box-shadow: 0 4px 14px rgba(42, 138, 234, 0.3);
    opacity: 1;
  }
}

.info__docs--desktop {
  display: inline-block;
  margin: 31px auto 0;

  @media (max-width: 767px) {
    display: none;
  }
}

.info__try-mobile {
  display: none;

  @media (max-width: 767px) {
    display: block;
    width: 100%;
    text-align: center;
    margin-top: 30px;
  }
}

.info__content {
  h2 {
    font-size: 31px;
    font-weight: bold;
    line-height: 1.23;
    color: rgb(27, 39, 51);

    @media (max-width: 413px) {
      font-size: 27px;
    }
  }

  p {
    font-size: 16px;
    line-height: 1.63;
    color: rgb(27, 39, 51);
    margin-top: 12px;

    @media (max-width: 767px) {
      margin-top: 16px;
    }

    @media (max-width: 413px) {
      font-size: 14px;
    }
  }
}

.info__label {
  display: inline-block;
  padding: 4px 10px;
  background: #624583;
  border-radius: 50px;
  font-weight: bold;
  font-size: 14px;
  line-height: 18px;
  color: #FFFFFF;
  margin-left: -9px;
  margin-bottom: 10px;
}
</style>
